import { FreeLookupAdmin } from './FreeLookupAdmin';

export default {
    list: FreeLookupAdmin,
};
